import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { MarkerActions } from "../../_actions";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { DevTool } from "@hookform/devtools";
import { useModal } from "../../_contexts";
import ReactTooltip from "react-tooltip";
import { getDefaultOverrides } from "../../_helpers";
import { useEventListener } from "../../_hooks";

import {
  Icon,
  Tabs,
  TagInput,
  Button,
  FormError,
  Checkbox,
  RelatedArticlePicker,
  PaneLoader,
  Toggle,
  ImageMarkerPicker,
  NumberPicker,
  SubGroupPicker,
} from "../../_components";
import { useColor } from "../../_hooks";
// Inconsistent RelatedArticleItems is because it's a factory, Location, Orgs, Chars all need similar treatment
export function MapMarkerForm({ map, marker, coords, chronicle, zoom }) {
  const allowFonts = false;
  ReactTooltip.rebuild();

  const [isLoading, setLoading] = useState(false);
  // const [showOverrides, setShowOverrides] = useState(false);
  const [showClearConfirmation, setShowConfirmation] = useState(false);
  const { closeModal } = useModal();
  const dispatch = useDispatch();

  // const { items: templates } = useSelector((state) => state.markerTemplates);

  const DEFAULT_OVERRIDES = new getDefaultOverrides();
  const { handleSubmit, control, errors, trigger, ...formMethods } = useForm({
    mode: "all",
    defaultValues: {
      title: marker?.title || "",
      description: marker?.description || "",
      markerType: marker?.markerType || "location", //label, location, hidden
      simpleMarker:
        marker && marker.simpleMarker !== undefined
          ? marker.simpleMarker
          : true,
      iconImg: marker?.iconImg || "default",
      coords: {
        x: marker?.coords.x || coords?.lng || 0,
        y: marker?.coords.y || coords?.lat || 0,
        z: marker?.coords.z || zoom || 0,
      },
      icon: marker?.icon || "",
      chronicle: marker?.chronicle || chronicle._id,
      parentMap: marker?.parentMap || map._id,
      tags: marker?.tags || [],
      private: marker?.private || false,
      subGroups: marker?.subGroups || [],
      options: {
        rise: marker?.options?.rise || false,
        riseOffset: marker?.options?.riseOffset || 0,
        opacity: marker?.options?.opacity || 1,
        zIndex: marker?.options?.zIndex || "",
        color: marker?.options?.color || "",
        textColor: marker?.options?.textColor || "",
        size: marker?.options?.size || "",
        customClass: marker?.options?.customClass || "",
        showTitlePopup:
          marker && marker.options.showTitlePopup !== undefined
            ? marker.options.showTitlePopup
            : true,
      },

      waID: marker?.waID || "",
      linkedArticles:
        marker?.linkedArticles && marker.linkedArticles.length > 0
          ? marker.linkedArticles
          : [],
      template: marker?.template || "",

      templateOverrides:
        marker && marker.templateOverrides
          ? { ...DEFAULT_OVERRIDES, ...marker.templateOverrides }
          : { ...DEFAULT_OVERRIDES },
      // linkedEvents: [] //Add later. Easy way to tag multiple events to link to this marker
    },
    shouldUnregister: false,
    criteriaMode: "all",
    reValidateMode: "all",
  });
  let templateOverrides;
  if (marker) {
    templateOverrides = marker.templateOverrides;
  }

  const maxImageSize = {
    width:
      templateOverrides && templateOverrides.pinImg
        ? templateOverrides.pinImg.width
        : 40,
    height:
      templateOverrides && templateOverrides.pinImg
        ? templateOverrides.pinImg.height
        : 40,
  };

  const { watch, setValue, getValues, formState } = formMethods;
  const { calculateFilter } = useColor();
  const onError = (errors) => {
    console.log("Form Errors", errors);
  };
  const onSubmit = (formData) => {
    // console.log("Formdata", { ...formData });
    // return;
    // return;
    setLoading(true);

    // console.log('Map Marker Form Data', formData);
    if (formData.waID && formData.waID === "") {
      formData.waID = null;
    }

    if (
      typeof formData.templateOverrides.primaryColor === "string" &&
      formData.templateOverrides.primaryColor !== ""
    ) {
      if (
        formData.templateOverrides.primaryColor !==
        marker.templateOverrides.primaryColor
      ) {
        // const filterResult = calculateFilter(formData.templateOverrides.primaryColor);
        // formData.templateOverrides.filter = filterResult.filter;
      }
    } else {
      // formData.templateOverrides.filter = '';
    }

    if (
      formData.templateOverrides &&
      formData.templateOverrides?.pinImg?.name === "Default Marker"
    ) {
      console.log("OVERRIDES");
      delete formData.templateOverrides.pinImg;
    }
    console.log("Form Data: ", { ...formData });

    if (marker && marker._id) {
      //verify data
      dispatch(MarkerActions.updateMarker(formData, marker._id)).then(
        (result) => {
          setLoading(false);
          closeModal();
        }
      );
    } else {
      dispatch(MarkerActions.createMarker(formData)).then(() => {
        setLoading(false);
        closeModal();
      });
    }
  };

  const handleCancel = () => {
    setLoading(false);
    closeModal();
  };

  const handleClear = () => {
    //set state for clearConfirm
    setShowConfirmation((isShown) => !isShown);
  };

  const handleClearTemplateOverrides = () => {
    //setvalues to default styles
    setValue("templateOverrides", { ...DEFAULT_OVERRIDES });
    //Reset the confirmation
    handleClear();
  };

  const { isValidating, isSubmitting, dirtyFields, touched } = formState;

  const handleKeyClose = (ev) => {
    // console.log("Key up: ", ev);
    if (ev.key && ev.key.toLowerCase() === "escape") {
      console.log("Form State: ", { ...formState });
      if (!isValidating && !isSubmitting) {
        if (
          Object.keys(dirtyFields).length === 0 &&
          Object.keys(touched).length === 0
        ) {
          // console.log("dirty fields!");
          handleCancel();
        }
      }
    }
  };

  useEventListener("keyup", handleKeyClose);

  const tooltipID = "chronosMarkerForm";
  const tooltipIcon = "fas fa-info-circle";

  const color = watch("templateOverrides.primaryColor");

  useEffect(async () => {
    console.log("COLOR UPDATE", color);
    if (color !== null && color !== "") {
      const filterResult = await calculateFilter(color, 50, 8);
      console.log("Result: ", filterResult);
      setValue("templateOverrides.filter", filterResult.filter);
    } else {
      setValue("templateOverrides.filter", "");
    }
  }, [color]);
  useEffect(() => {
    ReactTooltip.rebuild();
  }, [showClearConfirmation]);

  const handleTabChange = () => {
    ReactTooltip.rebuild();
    trigger();
  };

  return (
    <FormProvider
      handleSubmit={handleSubmit}
      control={control}
      watch={watch}
      {...formMethods}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="chronos-form chronos-modal-form"
      >
        <Tabs
          tabs={["General", "Pin", "Privacy", "Links"]}
          // onTabChange={handleTabChange}
        >
          <div>
            {/* <h3 className="form-title">General</h3> */}
            <div className="form-group">
              <label htmlFor="title" className="chronos-form-title">
                Title <sup className="required-flag">*</sup>
              </label>
              <Controller
                control={control}
                name="title"
                id="title"
                as="input"
                placeholder="Marker Title"
                className="form-control"
                rules={{
                  required: "You must have a title for this marker.",
                }}
              />
              {/* Errors: Title */}
              <ErrorMessage
                errors={errors}
                name="title"
                render={({ message }) => <FormError message={message} />}
              />
            </div>
            <div className="form-group">
              <label htmlFor="description" className="chronos-form-title">
                Description
              </label>
              <Controller
                control={control}
                name="description"
                id="description"
                as="textarea"
                className="form-control"
                autoComplete="off"
                style={{ height: "4em" }}
              />
              {/* Errors: Description */}
            </div>
            {/* <div className="form-group">
            <label htmlFor="markerType" className="chronos-form-title">
              Marker Type
            </label>
            <Controller
              control={control}
              name="markerType"
              render={({ onChange, value }) => (
                <Select
                  options={markerTypeOptions}
                  onChange={(items) => {
                    // console.log(items);
                    onChange(items[0].value);
                  }}
                  values={[markerTypeOptions.find((o) => o.value === value)]}
                  id="markerType"
                  valueField="value"
                  labelField="label"
                  searchField="label"
                  searchBy="label"
                  className="form-control chronos-select-component"
                  dropdownGap={0}
                  optionRenderer={({ item }) => (
                    <span
                      className="chronos-select-chosen-item"
                      key={item.value}
                    >
                      <Icon icon={item.icon} />
                      {item.label}
                    </span>
                  )}
                  itemRenderer={({ item, itemIndex, methods }) => (
                    <div
                      className="chronos-select-dropdown-item"
                      key={itemIndex}
                      onClick={() => methods.addItem(item)}
                    >
                      <Icon icon={item.icon} />
                      {item.label}
                    </div>
                  )}
                  contentRenderer={({ state }) => {
                    const item = state.values[0] || null;
                    return (
                      <div className="chronos-select-chosen-option">
                        {item && (
                          <React.Fragment>
                            <Icon icon={item.icon} />
                            {item.label}
                          </React.Fragment>
                        )}
                      </div>
                    );
                  }}
                />
              )}
              rules={{
                required: {
                  value: true,
                  message: 'You must specify what kind of Marker this is.',
                },
              }}
            />
            <ErrorMessage errors={errors} name="markerType" />
          </div> */}

            {/* <div className="form-section-header">
            <h3 className="form-section-title">Location</h3>
          </div>
          <div className="form-group">
            <label htmlFor="coords.x" className="chronos-form-title">Longitude</label>
            <Controller
              control={control}
              name="coords.x"
              id="coords.x"
              as="input"
              className="form-control chronos-input-display-only"
            />
          </div> */}
            <div className="form-group">
              <label htmlFor="tags" className="chronos-form-title">
                Tags&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="Tags help organize and make searching for this Map Marker easier for both you and your visitors."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="tags"
                id="tags"
                autoComplete="off"
                className="form-control"
                render={({ onChange, value }) => {
                  return (
                    <TagInput
                      value={value}
                      onlyUnique={true}
                      onChange={(e) => onChange(e)}
                      tagOnComma
                    />
                  );
                }}
              />
              {/* <p className="chronos-form-input-help">
              Press <kbd>,</kbd> to add a tag.
            </p> */}
            </div>
          </div>
          <div>
            {/* <h3 className="form-title">Display</h3> */}

            {/* Template Picker */}
            {/* <div className="form-group">
              <label htmlFor="template" className="chronos-form-title">
                Template &nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-for={tooltipID}
                  data-tip={`Selecting a Marker Template will change the appearance of this Map Marker when it is shown.`}
                />
              </label>
              <Controller
                control={control}
                name="template"
                id="template"
                render={({ value, onChange }) => (
                  <CustomMarkerTool
                    value={value}
                    onChange={onChange}
                    templates={templates}
                  />
                )}
              />
            </div> */}
            {/* <div className="form-group chronos-collapse">
              <label className="chronos-form-title">
                Advanced Options&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-for={tooltipID}
                  data-tip="Customize this Marker's display."
                />
              </label>
              <IconButton
                icon={
                  showOverrides
                    ? 'far fa-chevron-up fa-fw'
                    : 'far fa-chevron-down fa-fw'
                }
                onClick={() => setShowOverrides(!showOverrides)}
                iconOnly
                iconColor="#333"
              />
            </div> */}

            {allowFonts && (
              <div className="form-group">
                <label
                  htmlFor="templateOverides.mode"
                  className="chronos-form-title"
                >
                  Marker Image Type
                </label>
                <div className="form-group-h">
                  {/* <CustomMarkerPreview
                    markerImage={watch('templateOverrides.pinImg')}
                    primaryColor={watch('templateOverrides.primaryColor')}
                    keyPrefix="templateOverrides"
                    testPrefix="templateOverrides"
                    markVisible="templateOverrides"
                  /> */}
                  <Controller
                    control={control}
                    name="templateOverrides.mode"
                    render={({ value, onChange }) => (
                      <Toggle
                        checked={value === "image"}
                        id="templateOverrides.mode"
                        name="templateOverrides.mode"
                        onChange={(val) => onChange(val ? "image" : "icon")}
                        onText="Image"
                        offText="Icon"
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {watch("templateOverrides.mode") === "image" && (
              <React.Fragment>
                <div className="form-group">
                  <label
                    htmlFor="templateOverrides.pinImg"
                    className="chronos-form-title"
                  >
                    Select Pin
                  </label>
                  <Controller
                    control={control}
                    name="templateOverrides.pinImg"
                    render={({ value, onChange }) => {
                      const handleChange = (val) => {
                        // console.log("Upd", val);
                        if (
                          (val && val.name === "Default Marker") ||
                          val === null
                        ) {
                          setValue("templateOverrides.anchorX", 12);
                          setValue("templateOverrides.anchorY", 40);
                        } else {
                          setValue("templateOverrides.anchorX", 20);
                          setValue("templateOverrides.anchorY", 40);
                        }
                        onChange(val);
                      };
                      return (
                        <ImageMarkerPicker
                          value={value}
                          onChange={handleChange}
                          color={watch("templateOverrides.primaryColor")}
                          contextPrefix="templateOverrides"
                          tooltipID={tooltipID}
                          filter={watch("templateOverrides.filter")}
                        />
                      );
                    }}
                  />
                </div>
                {/* <div className="chronos-form-section-horizontal"> */}
                <div className="form-group">
                  <label className="chronos-form-title">
                    Pin Size&nbsp;
                    <Icon
                      icon={tooltipIcon}
                      data-for={tooltipID}
                      data-tip="This controls the Marker's dimensions, but may cause stretching or squishing"
                    />
                  </label>
                  <Controller
                    control={control}
                    name="templateOverrides.width"
                    render={({ value, onChange }) => {
                      const handleChange = (value) => {
                        if (getValues("templateOverrides.pinImg") === null) {
                          const currentWidth = getValues(
                            "templateOverrides.width"
                          );
                          const currentHeight = getValues(
                            "templateOverrides.height"
                          );
                          if (!isNaN(currentWidth) && !isNaN(currentHeight)) {
                            const ratio = currentWidth / currentHeight;
                            setValue(
                              "templateOverrides.height",
                              value + value * ratio
                            );
                          }
                        } else {
                          setValue("templateOverrides.height", value);
                        }
                        onChange(value);
                      };
                      return (
                        <NumberPicker
                          value={value}
                          onChange={handleChange}
                          max={maxImageSize.width}
                          // className="form-control"
                          min={0}
                        />
                      );
                    }}
                  />
                  {/* <label
                      htmlFor="templateOverrides.width"
                      className="chronos-form-title"
                    >
                      Width
                    </label> */}
                  {/* <Controller
                      control={control}
                      name="templateOverrides.width"
                      render={({ value, onChange }) => {
                        const handleChange = (val) => {
                          const isLockedAspect = getValues(
                            'templateOverrides.lockAspectRatio'
                          );
                          if (isLockedAspect) {
                            const { templateOverrides: dimensions } = getValues(
                              [
                                'templateOverrides.width',
                                'templateOverrides.height',
                              ]
                            );
                            console.log(dimensions);
                            const ratio = parseFloat(
                              (
                                (dimensions.height / dimensions.width) *
                                val
                              ).toFixed(2)
                            );
                            setValue('templateOverrides.height', ratio);
                          }
                          onChange(val);
                        };
                        return (
                          <NumberPicker
                            value={value}
                            onChange={handleChange}
                            min={1}
                            max={120}
                          />
                        );
                      }}
                    /> */}
                  {/* Height */}
                  {/* <label
                      htmlFor="templateOverrides.height"
                      className="chronos-form-title"
                    >
                      Height
                    </label> */}
                  {/* <Controller
                      control={control}
                      name="templateOverrides.height"
                      render={({ value, onChange }) => (
                        <NumberPicker
                          value={value}
                          onChange={onChange}
                          min={1}
                          max={120}
                        />
                      )}
                    /> */}
                  {/* Aspect Ratio */}
                  {/* <label className="chronos-form-title">
                          
                          Lock Aspect Ratio?&nbsp;
                          <Icon
                            icon={tooltipIcon}
                            data-for={tooltipID}
                            data-tip="This locks the size of the height and width of the image. This is useful to prevent issues with stretching."
                          />
                          
                          <Controller
                            control={control}
                            name="templateOverrides.lockAspectRatio"
                            render={({ value, onChange }) => {
                              return (
                                <Checkbox
                                  value={value}
                                  onChange={onChange}
                                  custom
                                />
                              );
                            }}
                          />
                        </label> */}
                  {/* </div> */}
                </div>
                {/* Color Shift (HUE HSL) */}
                {/* <div className="form-group">
                  <label
                    htmlFor="templateOverrides.primaryColor"
                    className="chronos-form-title"
                  >
                    Color Shift&nbsp;
                    <Icon
                      icon={tooltipIcon}
                      data-for={tooltipID}
                      data-tip="Applies a hue shift to the image. For best effect, it's best to select a Marker image that is either flat white or black. Other colors and shadows on the image may result in an undesired effect."
                    />
                  </label>
                  <Controller
                    control={control}
                    name="templateOverrides.primaryColor"
                    render={({ value, onChange }) => (
                      <ColorPicker
                        value={value}
                        onChange={onChange}
                        colorMode="hsl"
                      />
                    )}
                  />
                  <span className="chronos-form-help-text">
                    <Icon icon="far fa-exclamation-triangle fa-fw" />
                    &nbsp; Due to how browsers calculate colors, results may
                    vary.
                  </span>
                  <Controller
                    control={control}
                    name="templateOverrides.filter"
                    render={({ value, onChange }) => (
                      <input
                        value={value}
                        className="chronos-null"
                        style={{
                          position: "absolute",
                          width: 0,
                          height: 0,
                          top: -300,
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div> */}

                {/* Custom CSS Class */}
                <div className="form-group">
                  <label
                    htmlFor="templateOverrides.customClassName"
                    className="chronos-form-title"
                  >
                    Custom CSS Class&nbsp;
                    <Icon
                      icon={tooltipIcon}
                      data-for={tooltipID}
                      data-html={true}
                      data-tip={CSSTooltip()}
                    />
                  </label>
                  <Controller
                    control={control}
                    name="templateOverrides.customClassName"
                    as="input"
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                {/* Enable Tooltip */}
                <div className="form-group">
                  <label
                    htmlFor="templateOverrides.tooltipEnabled"
                    className="chronos-form-title chronos-custom-form-label"
                  >
                    Show Title on Hover?
                    <Controller
                      control={control}
                      name="templateOverrides.tooltipEnabled"
                      render={({ value, onChange }) => (
                        <Checkbox custom value={value} onChange={onChange} />
                      )}
                    />
                  </label>
                </div>
              </React.Fragment>
            )}
            {/* <div className="form-group">
              <label className="chronos-form-title">
                Reset Image&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-for={tooltipID}
                  data-tip="This will reset the Marker's image settings to their default values."
                />
              </label>
              <br />
              {!showClearConfirmation && (
                <Button
                  color="info"
                  onClick={handleClear}
                  // data-tip="Reset the values above to default."
                  // data-for={tooltipID}
                >
                  Reset
                </Button>
              )}
              {showClearConfirmation && (
                <div className="chronos-confirm-btn-group">
                  <Button
                    onClick={handleClear}
                    size="xs"
                    color="info"
                    data-tip="Cancel Reset"
                    data-for={tooltipID}
                  >
                    <Icon icon="far fa-times fa-fw" />
                  </Button>
                  <Button
                    onClick={handleClearTemplateOverrides}
                    size="xs"
                    color="danger"
                    data-tip="Confirm Reset"
                    data-for={tooltipID}
                  >
                    <Icon icon="far fa-check fa-fw" />
                  </Button>
                </div>
              )}
            </div> */}
          </div>

          {/* Privacy */}
          <div className="chronos-tab-pane">
            <div className="form-group">
              <label htmlFor="private" className="chronos-form-title">
                Privacy &nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-for={tooltipID}
                  data-tip="Make the Marker private. Only Subscriber Groups you choose will have access to see this Marker."
                />
              </label>
              <br />
              <Controller
                control={control}
                name="private"
                // id="private"
                render={({ value, onChange }) => (
                  <Toggle
                    id="private"
                    name="private"
                    checked={value}
                    onChange={onChange}
                    onText="Private"
                    offText="Public"
                    onColor="#dc3545"
                    offColor="#007bff"
                  />
                )}
              />
            </div>
            {/* Subscriber Groups */}
            {watch("private") === true && (
              <div className="form-group">
                <label htmlFor="subGroups" className="chronos-form-title">
                  Subscriber Groups&nbsp;
                  <Icon
                    icon={tooltipIcon}
                    data-tip="Choose the Subscriber Groups that will have access to this Marker. They'll appear on the right column."
                    data-for={tooltipID}
                  />
                </label>
                <Controller
                  control={control}
                  name="subGroups"
                  render={({ onChange, value }) => (
                    <SubGroupPicker value={value} onChange={onChange} />
                  )}
                />
              </div>
            )}
          </div>

          {/* Linked Articles */}
          <div>
            <div className="form-group">
              <label htmlFor="linkedArticles" className="chronos-form-title">
                Linked Articles
              </label>
              <Controller
                control={control}
                id="linkedArticles"
                name="linkedArticles"
                render={({ value, onChange }) => {
                  return (
                    <RelatedArticlePicker value={value} onChange={onChange} />
                  );
                }}
              />
            </div>
          </div>
        </Tabs>
        <div className="form-controls">
          {/* <Button color="secondary" type="button" onClick={handleCancel}>
            <Icon icon="fas fa-times fa-fw" />
            Cancel
          </Button> */}
          &nbsp;
          <Button type="submit" color="primary">
            <Icon icon="fas fa-save mr-2" />
            {marker && "Update"}
            {marker === undefined && "Create"}
          </Button>
        </div>
        <PaneLoader
          isLoading={isLoading}
          text="Marker"
          isNew={!(marker && marker._id)}
        />
        <ReactTooltip
          effect="solid"
          id={tooltipID}
          className="chronos-tooltip"
        />
        <DevTool control={control} />
      </form>
    </FormProvider>
  );
}

function TemplateHelpTooltip() {
  return `<div>
      Any options set below will override the Marker Template's setting.
      <span style="margin-bottom: 1rem; display: block;"></span>
      For example: If the Marker Template sets the size of the Marker to 20
      pixels, and below that same setting is 40 pixels, the latter will be used.
    </div>`;
}

function CSSTooltip() {
  return `<div>
      <p>You may add a CSS class to this Marker, allowing you to target it with CSS style rules. This will only apply to this Marker.</p>
      <p>If you add a Template to this Marker, any CSS classes in the Template will also be added. These CSS classes apply to all Markers that share the Template. All Markers that use any Template also has the CSS class <span class="chronos-code-text">chronos-template-marker</span>.</p>
      <p>Important Note: Every Marker also has the base CSS class of <span class="chronos-code-text">chronos-map-marker</span> and a unique class <span class="chronos-code-text">chronos-marker-UNIQUE-ID</span> (to target that Marker specifically). </p>
    </div>`;
}
// function AnchorAlignmentButtons({ handler: alignAnchor }) {
//   return (
//     <ButtonGrid rows={3} cols={3}>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('topleft')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(-45deg)' }}
//         />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('topcenter')}
//       >
//         <Icon icon="far fa-arrow-up fa-fw" />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('topright')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(45deg)' }}
//         />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('centerleft')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(-90deg)' }}
//         />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('centercenter')}
//       >
//         <Icon icon="far fa-dot-circle fa-fw" />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('centerright')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(90deg)' }}
//         />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('bottomleft')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(-135deg)' }}
//         />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('bottomcenter')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(180deg)' }}
//         />
//       </Button>
//       <Button
//         size="xs"
//         color="secondary"
//         onClick={() => alignAnchor('bottomright')}
//       >
//         <Icon
//           icon="far fa-arrow-up fa-fw"
//           style={{ transform: 'rotate(135deg)' }}
//         />
//       </Button>
//     </ButtonGrid>
//   );
// }
